export function calcularZoom(bounds: { north: number; south: number; east: number; west: number }, mapWidthPx = 800) {
	// mapWidthPx: largura do mapa em pixels (ajuste conforme seu layout)
	const WORLD_DIM = { height: 256, width: 256 };
	const ZOOM_MAX = 21;

	function latRad(lat: number) {
		const sin = Math.sin((lat * Math.PI) / 180);
		const radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
		return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
	}

	function zoom(mapPx: number, worldPx: number, fraction: number) {
		return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
	}

	const latFraction = (latRad(bounds.north) - latRad(bounds.south)) / Math.PI;
	const lngDiff = bounds.east - bounds.west;
	const lngFraction = (lngDiff < 0 ? lngDiff + 360 : lngDiff) / 360;

	const latZoom = zoom(mapWidthPx, WORLD_DIM.height, latFraction);
	const lngZoom = zoom(mapWidthPx, WORLD_DIM.width, lngFraction);

	return Math.min(latZoom, lngZoom, ZOOM_MAX);
}
